import React, { useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { NIZAM_ELEMENT_ID } from '../constants';

async function openNizamCheckout() {
  const Nizam = window.Nizam;
  if (!Nizam) {
    throw new Error('Nizam is not loaded');
  }
  if (typeof Nizam.ready === 'function') {
    await Nizam.ready();
  }
  if (typeof window.Nizam.openCheckout !== 'function') {
    throw new Error('Nizam checkout is unavailable');
  }
  window.Nizam.openCheckout(NIZAM_ELEMENT_ID);
}

const DonateButton = ({ className = '' }) => {
  const [opening, setOpening] = useState(false);

  const handleDonateClick = async () => {
    if (opening) return;
    setOpening(true);
    try {
      await openNizamCheckout();
    } catch (err) {
      console.error(err);
      alert('Could not open the donation form. Please try again.');
    } finally {
      setOpening(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleDonateClick}
      disabled={opening}
      className={`min-h-[44px] inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-forest px-4 sm:px-7 py-2.5 rounded-btn text-sm sm:text-btn font-bold transition-all duration-300 ease-in-out hover:-translate-y-0.5 shadow-card focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 disabled:opacity-60 ${className}`}
      aria-label="Donate (opens secure checkout)"
    >
      <FaHeart className="w-4 h-4 shrink-0" aria-hidden="true" />
      <span className="hidden sm:inline">{opening ? 'Opening…' : 'Donate'}</span>
      <span className="sr-only sm:hidden">Donate</span>
    </button>
  );
};

export default DonateButton;
